import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["project", "category"]
  static values = { categoriesUrl: String }

  connect() {
    this.updateCategoryState()
  }

  projectChanged() {
    const projectId = this.projectTarget.value
    if (projectId) {
      this.fetchCategories(projectId)
    } else {
      this.disableCategory()
    }
  }

  async fetchCategories(projectId) {
    const url = `${this.categoriesUrlValue}?project_id=${projectId}`
    try {
      const response = await fetch(url, {
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      if (response.ok) {
        const categories = await response.json()
        this.populateCategories(categories)
      }
    } catch (error) {
      console.error('Error fetching categories:', error)
    }
  }

  populateCategories(categories) {
    const select = this.categoryTarget
    select.innerHTML = '<option value=""></option>'
    categories.forEach(([label, value]) => {
      const option = document.createElement('option')
      option.value = value
      option.textContent = label
      select.appendChild(option)
    })
    select.disabled = false
    this.updateHint('')
  }

  disableCategory() {
    const select = this.categoryTarget
    select.innerHTML = '<option value=""></option>'
    select.disabled = true
    this.updateHint('Select a project first')
  }

  updateHint(text) {
    const hint = this.categoryTarget.parentElement.querySelector('.form-text')
    if (hint) {
      hint.textContent = text
    }
  }

  updateCategoryState() {
    if (!this.projectTarget.value) {
      this.disableCategory()
    }
  }
}
